import { OpenAPIApiClient } from '@fourthwall/services/dist/OpenAPIApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useOpenAPIConfigurationQuery = createQueryHook(OpenAPIApiClient.getConfiguration, {
  queryKey: ['openAPIConfiguration'],
})
